export function safeNum(v: unknown, fallback = 0): number {
  return typeof v === 'number' && Number.isFinite(v) ? v : fallback;
}

export function clamp(n: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, n));
}

export function fmt1(v: number): number {
  return Math.round(safeNum(v, 0) * 10) / 10;
}

export function fmtPct(v: number): string {
  return `${Math.round(safeNum(v, 0))}%`;
}

export function fmtDays(v: number): string {
  return `${fmt1(v)}d`;
}

export function fmtDaysFromHours(h: number): string {
  return fmtDays(safeNum(h, 0) / 24);
}

export function asISODate(d: Date): string {
  return d.toISOString().split('T')[0];
}

export function trendArrow(delta: number, invert = false): { s: string; cls: string } {
  const d = safeNum(delta, 0);
  const up = invert ? d < 0 : d > 0;
  const down = invert ? d > 0 : d < 0;
  if (up) return { s: '↑', cls: 'text-success' };
  if (down) return { s: '↓', cls: 'text-error' };
  return { s: '→', cls: 'opacity-60' };
}

export function psiBadge(psi: number): { label: string; cls: string } {
  const p = safeNum(psi, 0);
  if (p >= 80) return { label: 'Stable', cls: 'badge-success' };
  if (p >= 60) return { label: 'Watch', cls: 'badge-warning' };
  if (p >= 40) return { label: 'Risk', cls: 'badge-error' };
  return { label: 'Critical', cls: 'badge-error' };
}
